import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '../interfaces/address';

/**
 * Gibt den kompletten Namen (Vorname + Nachname) des Kunden aus
 */
@Pipe({name: 'street' })
export class StreetPipe implements PipeTransform {
  transform(value: Address): string {
    return `${value.Street} ${value.StreetNumber}`;
  }
}